/**
 * Module to handle the scroll implemented for the Sticky Nav Bar.
 *
 * This functionality is in the Sticky Bar located in the detail pages, community detail for now.
 * Is the responsible to do the scroll at the Right or Left when you scroll down or up in the page.
 *
 */
(function stickyBarScrollHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  /*
   * Dependencies as
   * if (!global.NewHomeSource.MyDependency) {
   *   return;
   * }
   */
  const previousStickyBarScrollModule = global.NewHomeSource.stickyBarScrollHandler;

  /**
   * @constructs NewHomeSource.StickyBarScrollHandler
   */
  function StickyBarScrollHandler() {}

  /**
   * Scrolls the Sticky Bar when we scroll the page.
   * @param {any} entry
   */
  StickyBarScrollHandler.moveStickyBarScroll = function moveStickyBarScroll(entry, element) {
    const container = document.querySelector('div[data-sticky-bar]');

    if (!container) {
      return;
    }

    const scrollElement = container.querySelector('.bar__item-active');    
    const rightPoint = container.getBoundingClientRect().right;
    const scrollLeft = container.scrollLeft;

    // Scroll to the active element.
    if (scrollElement) {
      const elementPoints = scrollElement.getBoundingClientRect();
      const elementRight = elementPoints.right;
      const elementWidth = elementPoints.width;

      const value = elementRight - rightPoint + elementWidth + scrollLeft;
      container.scrollTo({
        left: value,
        behavior: 'smooth',
      });
    }
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.StickyBarScrollHandler to the previous script.
   */
  StickyBarScrollHandler.noConflict = function noConflict() {
    global.NewHomeSource.Modules.stickyBarScrollHandler = previousStickyBarScrollModule;
    return StickyBarScrollHandler;
  };

  global.NewHomeSource.Modules.stickyBarScrollHandler = StickyBarScrollHandler;
})(window);
